import { useTheme } from '@mui/material';

type InputLabelProps = {
  label: string;
};

export function InputLabel({ label }: InputLabelProps) {
  const {
    palette: { mediumEmphasisTextLight },
  } = useTheme();
  return (
    <p
      style={{ color: mediumEmphasisTextLight }}
      className="text-xs font-semibold pb-1 m-0"
    >
      {label}
    </p>
  );
}
